import { get } from 'lodash';
import { ConfigurationService, checkIfTemplateExists, saveTemplateToFrontman } from '../services/ConfigurationService';
import { REFRESH_SELECTED_CONFIG_FILE } from '../constants/ActionTypes';

export const saveConfigurationFile = (selected, configCode, configToSave, newParams) => dispatch => {
    const {
        level,
        chain: { Id: chainId },
        selectedHotel: { id: hotelId }
    } = selected;
    const isConfigSaveAsNew = !configCode;
    const combinedConfigObj = {
        Data: configToSave,
        MetaData: {
            Comment: newParams.comments,
            Name: newParams.name
        }
    };

    const configPromise = isConfigSaveAsNew
        ? ConfigurationService.new(chainId, hotelId, newParams.code, combinedConfigObj, level)
        : ConfigurationService.update(chainId, hotelId, configCode, combinedConfigObj, level);
    return configPromise.then(response => {
        if (response.data.Result.ResultCode === 'SUCCESS') {
            if (isConfigSaveAsNew) {
                saveTemplateToFrontman({
                    code: newParams.code,
                    chainId,
                    hotelId,
                    saveLevel: level,
                    name: get(combinedConfigObj, 'MetaData.Name')
                });
            } else {
                checkIfTemplateExists({ chainId, hotelId, templateCode: configCode }).then(response => {
                    if (!response) {
                        saveTemplateToFrontman({
                            code: configCode,
                            chainId,
                            hotelId,
                            saveLevel: level,
                            name: get(combinedConfigObj, 'MetaData.Name')
                        });
                    }
                });
            }
            return ConfigurationService.reload(
                chainId,
                hotelId,
                level,
                isConfigSaveAsNew ? newParams.code : configCode,
                true
            ).then(() => {
                dispatch({ type: REFRESH_SELECTED_CONFIG_FILE });
            });
        } else {
            return Promise.reject(response.data.Result.ResultCode);
        }
    });
};



// WEBPACK FOOTER //
// ./src/actions/configuration.js